/**
 * `ez.t.item_moved_to_group` — *When an item moves to {group, groupId}* (recipes 24, 193).
 * monday exposes no `workflowBlockId` for it: it exists only inside `static` recipes and has no
 * new-builder replacement in the captured catalogue, which is the evidence that a local block is
 * the right model (`sandbox-experiments.md` E14). `$any$` is recipe 193's "any group".
 */
import { z } from 'zod';
import { defineTrigger } from '../block.js';
import { ANY_VALUE } from '../values.js';
export const itemMovedToGroupParams = z.object({
    groupId: z.union([z.literal(ANY_VALUE), z.string().min(1)]).default(ANY_VALUE),
});
export const itemMovedToGroupTrigger = defineTrigger({
    id: 'ez.t.item_moved_to_group',
    kind: 'trigger',
    app: 'monday',
    sentencePartial: 'When an item moves to {group, groupId}',
    paramsSchema: itemMovedToGroupParams,
    subscribes: ['item.moved'],
    assumed: true,
    references: (params) => (params.groupId === ANY_VALUE ? [] : [{ kind: 'group', id: params.groupId }]),
    matches(event, params) {
        const to = event.payload.groupId;
        const from = event.payload.previousGroupId;
        if (to === from)
            return false; // a reorder inside the group is not a move
        return params.groupId === ANY_VALUE || to === params.groupId;
    },
    outputs(event) {
        return {
            itemId: event.itemId,
            boardId: event.boardId,
            groupId: event.payload.groupId,
            previousGroupId: event.payload.previousGroupId,
        };
    },
});
//# sourceMappingURL=ez.t.item-moved-to-group.js.map